import revive_payload_client_4sVQNw7RlN from "/builds/racent/frontend/website_nicsrs/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import components_plugin_KR1HBZs4kY from "/builds/racent/frontend/website_nicsrs/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/builds/racent/frontend/website_nicsrs/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/racent/frontend/website_nicsrs/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "/builds/racent/frontend/website_nicsrs/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/builds/racent/frontend/website_nicsrs/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/builds/racent/frontend/website_nicsrs/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/builds/racent/frontend/website_nicsrs/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import animate_0v16OsOpyE from "/builds/racent/frontend/website_nicsrs/plugins/animate.js";
import carousel_client_qGB0nHi2Nh from "/builds/racent/frontend/website_nicsrs/plugins/carousel.client.js";
import error_handler_VFH3VvK7yG from "/builds/racent/frontend/website_nicsrs/plugins/error-handler.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  animate_0v16OsOpyE,
  carousel_client_qGB0nHi2Nh,
  error_handler_VFH3VvK7yG
]